/**
 * Apuracao do IRPJ — nao confundir com {@link TaxRegime} (o CRT da nota). Real, presumido e
 * arbitrado sao formas de apurar o imposto de renda de quem esta no regime normal; quem esta no
 * Simples ou MEI nao apura por aqui e o campo fica nulo.
 */
export enum IncomeTaxRegime {
  REAL = 'Lucro Real',
  PRESUMED = 'Lucro Presumido',
  ARBITRATED = 'Lucro Arbitrado',
}

export const incomeTaxRegimeOptions = [
  { value: 'REAL', label: IncomeTaxRegime.REAL },
  { value: 'PRESUMED', label: IncomeTaxRegime.PRESUMED },
  { value: 'ARBITRATED', label: IncomeTaxRegime.ARBITRATED },
];

/** So o regime normal (CRT 3) apura IRPJ; Simples, sublimite e MEI nao. */
export function usesIncomeTaxRegime(taxRegime?: string) {
  return taxRegime === 'NORMAL';
}
